import React from 'react'

import { Props } from './Alert'

type AlertBodyProps = React.HTMLAttributes<HTMLHeadElement> &
  Pick<Props, 'danger'>

const AlertBody: React.FC<AlertBodyProps> = ({ children, danger }) => (
  <div className={`text-base ${danger && 'text-white'}`}>{children}</div>
)

export default AlertBody
